(() => {
  const PREV_SVG = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  const NEXT_SVG = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function enhance(zoom) {
    if (zoom.dataset.customArrows === 'true') return;

    const dialog = zoom.querySelector('dialog');
    const gallery = zoom.querySelector('.dialog-zoomed-gallery');
    if (!dialog || !gallery) return;

    const slides = Array.from(gallery.children);
    if (slides.length < 2) return;

    zoom.dataset.customArrows = 'true';
    const thumbs = Array.from(zoom.querySelectorAll('.dialog-thumbnails-list__thumbnail'));

    const currentIndex = () => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      let bestIndex = 0;
      let bestArea = -1;
      slides.forEach((slide, index) => {
        const r = slide.getBoundingClientRect();
        const w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
        const h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
        const area = w * h;
        if (area > bestArea) { bestArea = area; bestIndex = index; }
      });
      return bestIndex;
    };

    const syncControls = () => {
      const index = currentIndex();
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-selected', String(i === index)));
      prev.disabled = index <= 0;
      next.disabled = index >= slides.length - 1;
    };

    const goTo = (index) => {
      const target = Math.min(Math.max(index, 0), slides.length - 1);
      if (typeof zoom.selectThumbnail === 'function') {
        zoom.selectThumbnail(target, { behavior: 'smooth' });
      } else {
        slides[target].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
      window.setTimeout(syncControls, 400);
    };

    const makeArrow = (direction, label, svg) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `custom-lightbox-arrow custom-lightbox-arrow--${direction}`;
      button.setAttribute('aria-label', label);
      button.innerHTML = svg;
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(currentIndex() + (direction === 'next' ? 1 : -1));
      });
      return button;
    };

    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    const prev = makeArrow('prev', 'Imagen anterior', PREV_SVG);
    const next = makeArrow('next', 'Imagen siguiente', NEXT_SVG);
    dialog.append(prev, next);

    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      event.stopPropagation();
      const forward = isRTL ? event.key === 'ArrowLeft' : event.key === 'ArrowRight';
      goTo(currentIndex() + (forward ? 1 : -1));
    });

    let scrollTimer = 0;
    const onScroll = () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncControls, 80);
    };
    gallery.addEventListener('scroll', onScroll, { passive: true });
    dialog.addEventListener('scroll', onScroll, { passive: true });
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => window.setTimeout(syncControls, 400)));

    syncControls();
  }

  const scan = (root) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll('zoom-dialog').forEach(enhance);
  };

  const start = () => {
    scan(document);
    new MutationObserver(() => scan(document)).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
